(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7399],{

/***/ 1759:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createElement = exports.appendNodeAsync = void 0;

var _utils = __webpack_require__(6336);

var resetLoadHandlers = function resetLoadHandlers(node, onload, onerror) {
  return function () {
    node.onload = onload;
    node.onerror = onerror;
  };
};

var appendNodeAsync = function appendNodeAsync(target, node, resolveCallback) {
  return new Promise(function (resolve, reject) {
    var resetHandlers = resetLoadHandlers(node, node.onload, node.onerror);
    node.onload = (0, _utils.handleWith)(resetHandlers, node.onload, function () {
      return resolve(typeof resolveCallback === 'function' ? resolveCallback() : undefined);
    });
    node.onerror = (0, _utils.handleWith)(resetHandlers, node.onerror, target.removeChild.bind(target, node), function () {
      return reject(new Error("Couldn't load ".concat(node.rel || node.tagName, " by url: ").concat(node.href || node.src)));
    });
    target.appendChild(node);
  });
};

exports.appendNodeAsync = appendNodeAsync;

var createElement = function createElement(tagName, nodeProps) {
  return Object.assign(__webpack_require__.g.document.createElement(tagName), nodeProps);
};

exports.createElement = createElement;

/***/ }),

/***/ 13750:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(64836);

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _domOps.appendNodeAsync;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _domOps.createElement;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _utils.cacheAll;
  }
});
exports.zf = exports.c7 = __webpack_unused_export__ = __webpack_unused_export__ = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(38416));

var _domOps = __webpack_require__(1759);

var _utils = __webpack_require__(6336);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var appendStyle = function appendStyle(href, nodeProps) {
  var resolveCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _utils.onlyIfFn)(nodeProps);
  return (0, _domOps.appendNodeAsync)(__webpack_require__.g.document.head, (0, _domOps.createElement)('link', _objectSpread({
    rel: 'stylesheet',
    href: href
  }, (0, _utils.onlyIfNotFn)(nodeProps))), resolveCallback);
};

__webpack_unused_export__ = appendStyle;

var appendScript = function appendScript(src, nodeProps) {
  var resolveCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (0, _utils.onlyIfFn)(nodeProps);
  return (0, _domOps.appendNodeAsync)(__webpack_require__.g.document.body, (0, _domOps.createElement)('script', _objectSpread({
    type: 'text/javascript',
    async: true,
    src: src
  }, (0, _utils.onlyIfNotFn)(nodeProps))), resolveCallback);
};

__webpack_unused_export__ = appendScript;
var importScript = (0, _utils.cacheAll)(appendScript);
exports.c7 = importScript;
var importStyle = (0, _utils.cacheAll)(appendStyle);
exports.zf = importStyle;

/***/ }),

/***/ 6336:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.handleWith = exports.onlyIfNotFn = exports.onlyIfFn = exports.cacheAll = void 0;

var identity = function identity(x) {
  return x;
};

var withCache = function withCache(cache, fn, getKey, checkCache) {
  return function () {
    var key = getKey.apply(void 0, arguments);
    if (checkCache && cache.has(key)) return cache.get(key);
    var result = fn.apply(void 0, arguments);
    cache.set(key, result);
    return result;
  };
};

var cacheAll = function cacheAll(fn) {
  var getKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  var cache = new Map();
  var cached = withCache(cache, fn, getKey, true);
  cached.force = withCache(cache, fn, getKey, false);
  return cached;
};

exports.cacheAll = cacheAll;

var onlyIfFn = function onlyIfFn(value, def) {
  return typeof value === 'function' ? value : def;
};

exports.onlyIfFn = onlyIfFn;

var onlyIfNotFn = function onlyIfNotFn(value, def) {
  return typeof value !== 'function' ? value : def;
};

exports.onlyIfNotFn = onlyIfNotFn;

var handleWith = function handleWith() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  var fnHandlers = handlers.filter(function (handler) {
    return typeof handler === 'function';
  });
  return function polyHandler() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    fnHandlers.forEach(function (handler) {
      return handler.apply(_this, args);
    });
  };
};

exports.handleWith = handleWith;

/***/ }),

/***/ 3074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports AlertRow, AlertLink */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42866);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74229);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25522);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(2349);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7820);










const AlertRow = (param)=>/*#__PURE__*/ {
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        sx: {
            fontSize: "m",
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(sx)
        },
        spacing: {
            my: 0,
            ...(0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(spacing)
        },
        ...props,
        children: children
    });
};
AlertRow.propTypes = {
    sx: _props_sx__WEBPACK_IMPORTED_MODULE_6__/* .sxPropTypes */ .I1,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_7__/* .spacingPropTypes */ .Xj,
    isLast: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    ..._Paragraph__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const AlertLink = (param)=>/*#__PURE__*/ {
    let { href , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        href: href,
        className: "alert__link",
        ...props,
        children: children
    });
};
AlertLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const Alert = (param)=>{
    let { title ="" , status ="success" , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("alert", "alert--".concat(status), className),
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                Tag: "h3",
                className: "alert__title",
                children: title
            }),
            children
        ]
    });
};
Alert.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_9__.node,
    status: (0,prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf)([
        "default",
        "success",
        "error",
        "warning"
    ]),
    className: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node.isRequired
};
Alert.Row = AlertRow;
Alert.Link = AlertLink;
/* harmony default export */ __webpack_exports__["ZP"] = (Alert);


/***/ }),

/***/ 94746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Paragraph__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74229);




const SimpleTemplateDescription = (param)=>{
    let { className ="" , center =true , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Paragraph__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        size: "l",
        center: center,
        className: className,
        ...props,
        children: children
    });
};
SimpleTemplateDescription.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateDescription);


/***/ }),

/***/ 3361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const SimpleTemplateForm = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        utility: {
            justify: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
            md: 8,
            children: children
        })
    });
};
SimpleTemplateForm.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateForm);


/***/ }),

/***/ 70504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);







const SimpleTemplateTitle = (param)=>{
    let { sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , className ="" , size ="xl" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            fontSize: size,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* .deepMergeProps */ .p)({
            mb: 6
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
SimpleTemplateTitle.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleTemplateTitle);


/***/ }),

/***/ 35449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js


// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel_Panel, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 37894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _fn__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

const fallback = (handler)=>(fn)=>{
        if (typeof handler !== "function") return fn;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            const theHandler = (err)=>handler(err, ...args);
            try {
                const result = fn(...args);
                return (0,_fn__WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.catch(theHandler) : result;
            } catch (err) {
                return theHandler(err);
            }
        };
    };
/* harmony default export */ __webpack_exports__["Z"] = (fallback);


/***/ }),

/***/ 71970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dv": function() { return /* binding */ Left; },
  "O6": function() { return /* binding */ Right; },
  "tS": function() { return /* binding */ chain; },
  "Gs": function() { return /* binding */ extRightStrict; },
  "ew": function() { return /* binding */ tapLeft; }
});

// UNUSED EXPORTS: LEFT, RIGHT, RightFrom, apply, biChain, biMap, biTap, chainLeft, extLeft, extLeftStrict, extRight, fromNullable, isLeft, isRight, leftFrom, map, mapLeft, match, of, strict, tap, validate

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/fn/toStr.js
const toStr_toStr = (value)=>typeof value === "symbol" ? value.toString() : "".concat(value);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/shared-utils/either/index.js

const LEFT = Symbol("__left__");
const RIGHT = Symbol("__right__");
const throwTypeError = (msg)=>{
    throw new TypeError(msg);
};
const Left = (error)=>({
        tag: LEFT,
        error
    });
const leftFrom = (fn)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Left(fn(...args));
    };
Left.from = leftFrom;
const Right = (result)=>({
        tag: RIGHT,
        result
    });
const RightFrom = (fn)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return Right(fn(...args));
    };
Right.from = RightFrom;
const fromNullable = (left)=>(value)=>value == null ? Left(left) : Right(value);
const of = (/* unused pure expression or super */ null && (Right));
const isLeft = (either)=>{
    return (either === null || either === void 0 ? void 0 : either.tag) === LEFT;
};
const isRight = (either)=>{
    return (either === null || either === void 0 ? void 0 : either.tag) === RIGHT;
};
const extLeft = (either)=>isLeft(either) ? either.error : undefined;
Left.extract = extLeft;
const extRight = (either)=>isRight(either) ? either.result : undefined;
Right.extract = extRight;
const chain = (chainFn)=>(either)=>isRight(either) ? chainFn(extRight(either)) : either;
const chainLeft = (chainFn)=>(either)=>isLeft(either) ? chainFn(extLeft(either)) : either;
const biChain = (leftChainFn, rightChainFn)=>(either)=>// prettier-ignore
        isRight(either) ? rightChainFn(extRight(either)) : isLeft(either) ? leftChainFn(extLeft(either)) : /* otherwise */ throwTypeError("".concat(toStr(either), " is not an either Left or Right"));
const extRightStrict = (either)=>isRight(either) ? either.result : throwTypeError("".concat(toStr_toStr(either), " is not Right"));
const extLeftStrict = (either)=>isLeft(either) ? either.error : throwTypeError("".concat(toStr_toStr(either), " is not Left"));
const strict = {
    extLeft: extLeftStrict,
    extRight: extRightStrict
};
const match = (onLeft, onRight)=>(either)=>// prettier-ignore
        isLeft(either) ? onLeft(extLeft(either)) : isRight(either) ? onRight(extRight(either)) : /* otherwise */ throwTypeError("".concat(toStr(either), " is not an either Left or Right"));
const tap = (effect)=>(either)=>{
        if (isRight(either)) effect(extRight(either));
        return either;
    };
const tapLeft = (effect)=>(either)=>{
        if (isLeft(either)) effect(extLeft(either));
        return either;
    };
const biTap = (leftEffect, rightEffect)=>(either)=>{
        if (isRight(either)) rightEffect(extRight(either));
        if (isLeft(either)) leftEffect(extLeft(either));
        return either;
    };
const map = (mapper)=>(either)=>// prettier-ignore
        isRight(either) ? Right(mapper(extRight(either))) : either;
const mapLeft = (mapper)=>(either)=>// prettier-ignore
        isLeft(either) ? Left(mapper(extLeft(either))) : either;
const biMap = (leftMapper, rightMapper)=>(either)=>// prettier-ignore
        isRight(either) ? Right(rightMapper(extRight(either))) : isLeft(either) ? Left(leftMapper(extLeft(either))) : /* otherwise */ throwTypeError("".concat(toStr(either), " is not an either Left or Right"));
const apply = (argEither)=>chain((fn)=>isLeft(argEither) ? argEither //
         : Right(fn(extRight(argEither))));
const validate = (validator)=>chain((value)=>{
        const validationResult = validator(value);
        return isLeft(validationResult) ? validationResult : Right(value);
    });


/***/ }),

/***/ 77915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10455);

/**
 * Type `SyncType<T>` - Type extracts type packed into the Promise
 *
 * @template T
 * @typedef {T extends Promise<infer Packed> ? Packed : T} SyncType
 */ const packToBuf = (buffer, field)=>(result)=>{
        // eslint-disable-next-line no-param-reassign
        buffer[field] = result;
        return buffer;
    };
const resolveToBuffer = (param)=>{
    let [field, resolver] = param;
    return (args, buffer)=>{
        try {
            const result = resolver(...args);
            const pack = packToBuf(buffer, field);
            return (0,___WEBPACK_IMPORTED_MODULE_0__/* .isPromise */ .tI)(result) ? result.then(pack) : pack(result);
        } catch (err) {
            return Promise.reject(err);
        }
    };
};
const resolversWrapper = (resolvers)=>function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const buffer = {};
        const promises = resolvers.map((0,___WEBPACK_IMPORTED_MODULE_0__/* .call */ .RE)(args, buffer));
        return Promise.all(promises).then(()=>buffer);
    };
const prepareResolvers = (param)=>{
    let [field, resolver] = param;
    return resolveToBuffer([
        field,
        (0,___WEBPACK_IMPORTED_MODULE_0__/* .ensureFunc */ .KX)(resolver, ()=>resolver)
    ]);
};
/**
 * Creates new functions that returns Promise resolving to an object with
 * values returned by functions specified for correspondent fields of argument
 * object
 *
 * @example
 * const fn = propsResolver({
 * 	x: () => 1,
 *  y: () => 2,
 * });
 * fn().then(console.log); // prints: { x: 1, y: 2 }
 *
 * @type {
 	<
		A extends any[],
		M extends { [p in string]: (...args: any[]) => any }
	>(resolversMap: M) => (...args: A) => Promise<{ [k in keyof M]: SyncType<ReturnType<M[k]>> }>
 }
 */ const propsResolver = (resolversMap)=>resolversWrapper(Object.entries(resolversMap).map(prepareResolvers));
/* harmony default export */ __webpack_exports__["Z"] = (propsResolver);


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 42202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable no-console */ 
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    data: null,
    container: null,
    run: (fn)=>{
        console.warn("Cannot run function in di-context, due it is not provided");
        console.log({
            fn: fn && (fn.name || fn.toString())
        });
    }
}));


/***/ }),

/***/ 43579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Wl": function() { return /* reexport */ google_recaptcha_GoogleRecaptchaNotice; }
});

// UNUSED EXPORTS: DEFAULT_GLOBAL_NAME, HIDDEN_BADGE_CSS, getRecaptchaUrl, useFormActionWithGoogleCaptcha, useGoogleRecaptcha

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/assets-dynamic-import/lib/index.js
var lib = __webpack_require__(13750);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/google-recaptcha/useGoogleRecaptcha.js




const prepareGrecaptcha = (grecaptcha)=>new Promise((resolve)=>grecaptcha.ready(()=>resolve(grecaptcha)));
function useGoogleRecaptcha_useGoogleRecaptcha(cb, param) {
    let { siteKey , action ="submit" , globalName =DEFAULT_GLOBAL_NAME , badgeCss =HIDDEN_BADGE_CSS  } = param;
    if (!siteKey) return cb;
    const grecaptchaRef = useRef(null);
    useEffect(()=>{
        importScript(getRecaptchaUrl(siteKey), ()=>__webpack_require__.g[globalName]).then(prepareGrecaptcha).then((grecaptcha)=>{
            grecaptchaRef.current = grecaptcha;
        });
        if (badgeCss) addStyle(badgeCss);
    }, [
        siteKey,
        globalName
    ]);
    const wrappedCb = useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        const grecaptcha = grecaptchaRef.current;
        if (grecaptcha == null) throw new TypeError("grecaptcha is not initialized correctly");
        return grecaptcha.execute(siteKey, {
            action
        }).then((token)=>cb(...args, token));
    }, [
        siteKey,
        cb
    ]);
    return wrappedCb;
}

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/useTracking/index.js
var smart_react_useTracking = __webpack_require__(59074);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js + 2 modules
var DiPageHoC = __webpack_require__(74063);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useActionResult.js
var hooks_useActionResult = __webpack_require__(99112);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hooks/useActionError.js
var hooks_useActionError = __webpack_require__(64350);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/captcha/useFormActionWithCaptcha.js




function useFormActionWithCaptcha_useFormActionWithCaptcha(formAction, param) {
    let { endOn , useHook , ...captchaConfig } = param;
    const actionWithDi = useRun(formAction);
    const actionWithCaptcha = useHook(actionWithDi, captchaConfig);
    const [actionWithResult, { error , result , reset  }] = useActionResult(actionWithCaptcha);
    const [trackableAction, isLoading] = useTracking(actionWithResult, endOn);
    return [
        useActionError(trackableAction),
        {
            error,
            result,
            isLoading,
            reset
        }
    ];
}
/* harmony default export */ var captcha_useFormActionWithCaptcha = ((/* unused pure expression or super */ null && (useFormActionWithCaptcha_useFormActionWithCaptcha)));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/google-recaptcha/useFormActionWithGoogleCaptcha.js


function useFormActionWithGoogleCaptcha(formAction, captchaConfig) {
    return useFormActionWithCaptcha(formAction, {
        ...captchaConfig,
        useHook: useGoogleRecaptcha
    });
}
/* harmony default export */ var google_recaptcha_useFormActionWithGoogleCaptcha = ((/* unused pure expression or super */ null && (useFormActionWithGoogleCaptcha)));

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/google-recaptcha/GoogleRecaptchaNotice.js



const GoogleRecaptchaNotice = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Col */.JX, {
        shrink: true,
        sx: {
            fontSize: "xs",
            fontColor: "black--40"
        },
        ...props,
        children: [
            "Protected by reCAPTCHA (Google ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://policies.google.com/privacy",
                children: "Privacy Policy"
            }),
            " ",
            "and ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "https://policies.google.com/terms",
                children: "Terms of Service"
            }),
            " apply)"
        ]
    });
/* harmony default export */ var google_recaptcha_GoogleRecaptchaNotice = (GoogleRecaptchaNotice);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/google-recaptcha/index.js






/***/ }),

/***/ 91491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DiPageHoC_DiPageHoC; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/displayName.js
var displayName = __webpack_require__(75511);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/context.js
var context = __webpack_require__(18018);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hoc-merge-props.js

const merge = (propName)=>(props, value)=>({
            ...props,
            [propName]: {
                value,
                toJSON: ()=>null
            }
        });
const extract = (propName)=>{
    return (props)=>{
        var ref;
        const value = (ref = props[propName]) === null || ref === void 0 ? void 0 : ref.value;
        const propsCopy = {
            ...props
        };
        delete propsCopy[propName];
        return [
            value,
            propsCopy
        ];
    };
};
const getPropsAndMerge = (mergeFn)=>function(getProps, value) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
            args[_key - 2] = arguments[_key];
        }
        const props = (0,fn/* isFunc */.Wl)(getProps) ? getProps(...args) : null;
        return (0,fn/* isPromise */.tI)(props) ? props.then((resolved)=>mergeFn(resolved, value)) : mergeFn(props, value);
    };
const NotSerializableProp = (propName)=>{
    const ownMerge = merge(propName);
    return {
        merge: ownMerge,
        extract: extract(propName),
        getPropsAndMerge: getPropsAndMerge(ownMerge)
    };
};
/* harmony default export */ var hoc_merge_props = (NotSerializableProp);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/DiPageHoC.js






const { merge: DiPageHoC_merge , extract: DiPageHoC_extract  } = hoc_merge_props("container");
const useIsomorphicEffect =  false ? 0 : react.useLayoutEffect;
const DiPageHoC = (createContainer)=>(Page)=>{
        const DiPage = (pageProps)=>{
            const [containerFromProps, data] = DiPageHoC_extract(pageProps);
            const container = (0,react.useMemo)(()=>containerFromProps !== null && containerFromProps !== void 0 ? containerFromProps : createContainer(null), []);
            const [state, setState] = (0,react.useState)(data);
            const stateRef = (0,react.useRef)();
            stateRef.current = state;
            const updateState = (0,react.useCallback)((statePatch)=>{
                const newState = typeof statePatch === "function" ? statePatch(stateRef.current) : statePatch;
                stateRef.current = newState;
                setState(newState);
            }, [
                setState
            ]);
            useIsomorphicEffect(()=>{
                if (state === data) return;
                updateState(data);
            }, [
                pageProps
            ]);
            const run = react.useCallback((fn)=>fn(container, stateRef.current, run, updateState), [
                container
            ]);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
                value: {
                    run,
                    data: state,
                    container,
                    setState: updateState
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Page, {
                    ...data
                })
            });
        };
        Object.assign(DiPage, Page); // copying all static props
        DiPage.displayName = (0,displayName/* default */.Z)("withDiContext", Page);
        DiPage.getInitialProps = (context)=>{
            const container = createContainer(context);
            const runGetInitProps = (fn)=>fn(context, container, runGetInitProps);
            const props = typeof Page.getInitialProps === "function" ? runGetInitProps(Page.getInitialProps) : null;
            return (0,fn/* isPromise */.tI)(props) ? props.then((resolved)=>DiPageHoC_merge(resolved, container)) : DiPageHoC_merge(props, container);
        };
        return DiPage;
    };
/* harmony default export */ var DiPageHoC_DiPageHoC = (DiPageHoC);


/***/ }),

/***/ 18018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _di_context_context__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _di_context_context__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42202);



/***/ }),

/***/ 74063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Vi": function() { return /* reexport */ usePageData; },
  "Sr": function() { return /* reexport */ useRun; },
  "Su": function() { return /* reexport */ useServices; }
});

// UNUSED EXPORTS: default, useData, useExec

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/context.js
var DiPageHoC_context = __webpack_require__(18018);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/fn/index.js
var fn = __webpack_require__(10455);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/di-context/context.js
var di_context_context = __webpack_require__(42202);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/di-context/hooks.js



let deprecationWarning = ()=>{
    // eslint-disable-next-line no-console
    console.warn('useData hook is deprecated. Use "usePageData instead."');
    deprecationWarning = ()=>{};
};
const usePageData = function() {
    let selector = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : fn/* idX */.Yr;
    return selector(react.useContext(di_context_context/* default */.Z).data);
};
const useData = (selector)=>{
    deprecationWarning();
    return usePageData(selector);
};
const useRun = (action)=>{
    const { run  } = react.useContext(di_context_context/* default */.Z);
    return (0,react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return run(action(...args));
    }, [
        action,
        run
    ]);
};
const useExec = (thunk, deps)=>{
    const { run  } = React.useContext(context);
    return useMemo(()=>run(thunk), deps);
};

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/hooks.js



const useServices = function() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    const { container  } = react.useContext(DiPageHoC_context/* default */.Z);
    return react.useMemo(()=>names.map((name)=>container[name]), names);
};

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/DiPageHoC.js + 1 modules
var DiPageHoC = __webpack_require__(91491);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/smart-react/hocs/DiPageHoC/index.js




/***/ }),

/***/ 64350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37894);


/**
 * Catches the action exception and re-raizes
 * it into the React rendering context
 *
 * @type {<A extends any[], R>(action: (...args: A) => R) => (...args: A) => R}
 */ function useActionError(action) {
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (error) throw error;
    }, [
        error
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_shared_utils_async_fallback__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(setError)(action), [
        action
    ]);
}
/* harmony default export */ __webpack_exports__["Z"] = (useActionError);


/***/ }),

/***/ 99112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86594);
/* harmony import */ var _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71970);
/* harmony import */ var _useUnmounted__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23740);




function useActionResult(formAction) {
    const unmounted = (0,_useUnmounted__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const [either, setResult] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((0,_insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Right */ .O6)());
    const updateResult = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((res)=>{
        if (unmounted.current) return;
        setResult(res);
    }, [
        setResult
    ]);
    const action = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>(0,_insightfulscience_shared_utils_async_then__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(updateResult)(formAction), [
        formAction
    ]);
    const reset = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>updateResult((0,_insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Right */ .O6)()), [
        formAction
    ]);
    const error = _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Left.extract */ .dv.extract(either);
    const result = _insightfulscience_shared_utils_either__WEBPACK_IMPORTED_MODULE_2__/* .Right.extract */ .O6.extract(either);
    return [
        action,
        {
            error,
            result,
            reset
        }
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useActionResult);


/***/ }),

/***/ 38416:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(64062);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64836:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 95036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 64062:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(18698)["default"]);
var toPrimitive = __webpack_require__(95036);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 18698:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

}]);